"use client";
import { useEffect, useState } from "react";
import {
  NextButton,
  PrevButton,
} from "../../../../../components/new_components/buttonsFlow";
import { ReactComponent as GalileIcon } from "../../../../../public/logos/galilea-icono.svg";
import AnimationComponent from "../../../../../components/new_components/animation";
import StepInput from "../../../../../components/new_components/StepInput";
import { useWindowSize } from "../../../helpers/bankDimensions";
import { stepsCreditStore } from "../../../../../store/creditStore/stepsCreditStore";
import { variablesGlobales } from "../../../../../configs/variables";
import axios from "axios";
import { useAlert } from "../provider/alertProvider";
import { normalizeMessage } from "../cardComponents/normalizeMessage";
import { CheckboxItem } from "../cardComponents/checkBoxItem";

const AutoAdvance = ({ onNext, delay }) => {
  useEffect(() => {
    const t = setTimeout(onNext, delay);
    return () => clearTimeout(t);
  }, [onNext, delay]);
  return null;
};

// ════════════════════════════════════════════════════════════════
// STEP 1 — Número de producto
// ════════════════════════════════════════════════════════════════
const Step1 = ({ onNext, onBack, isDesktop, product, setProduct }) => {
  const [error, setError] = useState("");

  const { height } = useWindowSize();

  const heightContainer =
    height < 700 ? "46dvh" : height <= 840 ? "65dvh" : "69dvh";

  let gapContainer =
    window.innerHeight < 700
      ? "25px"
      : window.innerHeight > 700 && window.innerHeight < 899
        ? "15px"
        : window.innerHeight > 900 && "60px";

  const handleChange = (e) => {
    const val = e.target.value
      .replace(/[^0-9]/g, "") // ← elimina TODO lo que no sea 0-9 (más estricto que \D)
      .slice(0, 10);

    if (val !== e.target.value.slice(0, 10)) return; // ← rechaza si hubo caracteres inválidos

    setProduct(val);
    if (error) setError("");
  };

  const handleKeyDownOnlyNumbers = (e) => {
    const allowed = [
      "Backspace",
      "Delete",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
    ];
    if (allowed.includes(e.key)) return;
    if (e.ctrlKey || e.metaKey) return;
    if (!/^[0-9]$/.test(e.key)) e.preventDefault();
  };

  const handleNext = () => {
    if (!/^3\d{9}$/.test(product)) {
      setError("Ingresa un número válido (10 dígitos, inicia en 3)");
      return;
    }
    onNext();
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: isDesktop ? "-webkit-fill-available" : heightContainer,
        padding: isDesktop ? "0 80px" : "0",
        width: "100%",
        gap: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: isDesktop ? gapContainer : "16px",
          flex: 1,
        }}
        className="p-4"
      >
        {/* Título */}
        <div>
          {isDesktop ? (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  flexWrap: "wrap",
                }}
              >
                <span
                  style={{
                    fontSize: "clamp(18px, 4vw, 40px)",
                    fontWeight: 800,
                    color: "#fff",
                  }}
                >
                  Conexión con
                </span>
                <img
                  src="/png/nequi.png"
                  alt="Nequi"
                  style={{
                    maxWidth: "none",
                    height: "35px",
                    width: "120px",
                  }}
                />
              </div>
              <p
                style={{
                  color: "#9b93b8",
                  fontSize: "clamp(14px, 1.2vw, 18px)23px",
                  marginTop: "4px",
                }}
              >
                Digita el número de Nequi donde recibes tus ingresos.
              </p>
            </>
          ) : (
            <div className="flex justify-center">
              {" "}
              <img
                src="/png/nequi.png"
                alt="Nequi"
                style={{
                  maxWidth: "none",
                  height: "75px",
                  width: "200px",
                }}
              />
            </div>
          )}
        </div>

        {/* ← Input de número de producto — usa tu componente aquí */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ width: isDesktop ? "400px" : "100%" }}>
            <StepInput
              name="product"
              value={product}
              maxLength={10}
              minLength={3}
              label="Número de Nequi"
              onChange={handleChange}
              onKeyDown={handleKeyDownOnlyNumbers}
              error={error}
              placeholder="3017138594"
              type="number"
              inputMode="numeric"
              required
              autoFocus
              isDesktop={isDesktop}
            />
          </div>
        </div>

        {/* Resumen de conexión */}
        <div className="flex justify-center">
          <div
            style={{
              background: "#565584",
              borderRadius: "14px",
              padding: isDesktop ? "20px 24px" : "14px 16px",
              display: "flex",
              flexDirection: "column",
              gap: isDesktop ? "14px" : "10px",
              width: isDesktop && "500px",
            }}
          >
            <span
              style={{ fontWeight: 700, color: "#E1DFE5", fontSize: "15px" }}
            >
              Resumen de conexión
            </span>
            {[
              "Recibirás una notificación en tu app Nequi, acaptala para continuar.",
              "Paga tu crédito de forma más rápida y segura.",
              "Al finalizar, continuarás con el desembolso de tu crédito.",
            ].map((text, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "flex-start",
                }}
              >
                {/* Check activo no manipulable */}
                <div
                  style={{
                    minWidth: "18px",
                    height: "18px",
                    borderRadius: "50%",
                    background: "rgb(41 33 79)",
                    flexShrink: 0,
                    marginTop: "2px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <path
                      d="M2 5l2.5 2.5L8 3"
                      stroke="#fff"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <span
                  style={{
                    color: "white",
                    fontSize: isDesktop ? "14px" : "13px",
                    lineHeight: "1.4",
                  }}
                >
                  {text}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Botones */}
      <div
        style={{
          display: "flex",
          justifyContent: isDesktop ? "flex-end" : "stretch",
        }}
      >
        <div
          style={{
            width: isDesktop ? "400px" : "-webkit-fill-available",
            display: "flex",
          }}
        >
          <PrevButton onBack={onBack} label="Atrás" isMobile={!isDesktop} />
          <NextButton
            onNext={handleNext}
            label="Continuar"
            isMobile={!isDesktop}
            disabled={!product}
          />
        </div>
      </div>
    </div>
  );
};

// ════════════════════════════════════════════════════════════════
// STEP 2 — Connecting animation
// ════════════════════════════════════════════════════════════════

const Step2 = ({ onNext, isDesktop }) => {
  const { width } = useWindowSize();

  const isMedium = isDesktop && width > 1600;

  return (
    <div
      className="flex flex-col w-full items-center"
      style={{
        paddingTop: "20px",
        paddingLeft: isDesktop ? "clamp(60px, 7vw, 80px)" : "0",
        paddingRight: isDesktop ? "clamp(60px, 7vw, 80px)" : "0",
        gap: isDesktop ? (isMedium ? "120px" : "70px") : "70px",
      }}
    >
      <style>{`
        @keyframes bounce {
          0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
          40% { transform: translateY(-10px); opacity: 1; }
        }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>

      <h2
        style={{
          color: "#fff",
          fontWeight: 800,
          fontSize: "clamp(20px, 3vw, 28px)",
          textAlign: "center",
          alignSelf: "flex-start",
        }}
      >
        Conectando tu con tu banco Nequi
      </h2>

      {/* Logos + dots */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "16px",
          margin: "8px 0",
        }}
      >
        {/* Logo Galilea */}
        <GalileIcon
          style={{
            width: isDesktop ? (isMedium ? "180px" : "100px") : "80px",
            height: isDesktop ? (isMedium ? "110px" : "100px") : "80px",
          }}
          alt="Galilea"
        />

        {/* Dots animados */}
        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              style={{
                width: isDesktop ? "14px" : "12px",
                height: isDesktop ? "14px" : "12px",
                borderRadius: "50%",
                backgroundColor: "white",
                animation: `bounce 1.2s ease-in-out ${i * 0.15}s infinite`,
                display: "flex",
                gap: "30px",
              }}
            />
          ))}
        </div>
        <img
          src="/png/nequi.png"
          alt="Nequi"
          style={{
            maxWidth: "none",
            height: isDesktop ? (isMedium ? "80px" : "60px") : "50px",
            width: isDesktop ? (isMedium ? "200px" : "150px") : "150px",
          }}
        />
      </div>

      {/* Card con checks */}
      <div
        style={{
          background: "#565584",
          borderRadius: "14px",
          padding: isDesktop ? "20px 24px" : "14px 16px",
          display: "flex",
          flexDirection: "column",
          gap: isDesktop ? "14px" : "10px",
        }}
      >
        {[
          "Recibirás una notificación en tu app Nequi. Acéptala para continuar.",
          "Paga tu crédito de forma más rápida y segura.",
          "Tus pagos se procesarán de forma segura.",
        ].map((text, i) => (
          <div
            key={i}
            style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}
          >
            {/* Check activo no manipulable */}
            <div
              style={{
                minWidth: "18px",
                height: "18px",
                borderRadius: "50%",
                background: "rgb(41 33 79)",
                flexShrink: 0,
                marginTop: "2px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path
                  d="M2 5l2.5 2.5L8 3"
                  stroke="#fff"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <span
              style={{
                color: "white",
                fontSize: isDesktop ? "14px" : "13px",
                lineHeight: "1.4",
              }}
            >
              {text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

// ════════════════════════════════════════════════════════════════
// STEP 3 — Todo listo para conectar (disclosure + checkboxes)
// ════════════════════════════════════════════════════════════════

const Step3 = ({ onNext, onBack, isDesktop, statusIdWompi }) => {
  const [accepted, setAccepted] = useState({ terms: true, data: true });
  const allAccepted = accepted.terms && accepted.data;

  const { width, height } = useWindowSize();

  const isMedium = isDesktop && width < 1600;

  const heightContainer =
    height < 700 ? "62dvh" : height <= 840 ? "65dvh" : "69dvh";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: isDesktop ? "-webkit-fill-available" : heightContainer,
        padding: isDesktop ? "0 80px" : "0",
        width: "100%",
        gap: "10px",
        overflowY: "auto",
      }}
    >
      {/* Bloque superior */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: isDesktop ? (isMedium ? "15px" : "70px") : "25px",
          flex: 1,
        }}
        className="p-4"
      >
        {/* Título */}
        <div>
          <h2
            style={{
              fontSize: isDesktop ? "clamp(28px, 4vw, 40px)" : "22px",
              fontWeight: 800,
              color: "#fff",
              marginBottom: "4px",
            }}
          >
            Todo listo para conectar
          </h2>
          <p
            style={{
              color: "#9b93b8",
              fontSize: isDesktop ? "14px" : "12px",
              lineHeight: "1.4",
              margin: 0,
            }}
          >
            Al continuar, autorizas la conexión entre tu banco y Galilea. No
            almacenaremos tus claves ni datos sensibles.
          </p>
        </div>

        {/* Card banco seleccionado */}
        <div className="flex flex-col items-center">
          <div
            style={{
              background: isDesktop ? "rgb(26 24 48)" : "rgb(41, 33, 79)",
              borderRadius: "14px",
              padding: isDesktop ? "20px 24px" : "12px 16px",
              display: "flex",
              flexDirection: "column",
              gap: isDesktop ? "5px" : "8px",
              width: isDesktop && "500px",
            }}
          >
            <span
              style={{
                fontSize: "10px",
                fontWeight: 700,
                color: "#9b93b8",
                letterSpacing: "1.5px",
              }}
            >
              BANCO SELECCIONADO
            </span>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div>
                {/* <p
                  style={{
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: isDesktop ? "18px" : "15px",
                    margin: "0 0 2px",
                  }}
                >
                  Nequi
                </p> */}
                <img
                  src="/png/nequi.png"
                  alt="Nequi"
                  style={{
                    maxWidth: "none",
                    height: isDesktop ? (isMedium ? "35px" : "40px") : "40px",
                    width: isDesktop ? (isMedium ? "120px" : "140px") : "150px",
                  }}
                />
                <span
                  style={{
                    fontSize: "10px",
                    fontWeight: 700,
                    color: "#6fcf97",
                    letterSpacing: "1px",
                  }}
                >
                  {statusIdWompi === "APPROVED" ? "AUTORIZADA" : "PENDIENTE"}
                </span>
              </div>
            </div>
            <div
              style={{
                background: "#3d3870",
                borderRadius: "8px",
                padding: "8px 12px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <div
                style={{
                  minWidth: "18px",
                  height: "18px",
                  borderRadius: "50%",
                  background: "rgb(41 33 79)",
                  flexShrink: 0,
                  marginTop: "2px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path
                    d="M2 5l2.5 2.5L8 3"
                    stroke="#fff"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span
                style={{
                  color: "#C9B8FF",
                  fontSize: isDesktop ? "13px" : "12px",
                }}
              >
                Recibirás una notificación en tu app Nequi. Acéptala para
                continuar.
              </span>
            </div>
          </div>
        </div>

        {/* Aceptaciones */}
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <CheckboxItem
            checked={accepted.terms}
            onChange={() =>
              setAccepted((prev) => ({ ...prev, terms: !prev.terms }))
            }
          >
            Acepto haber leído{" "}
            <strong style={{ color: "#fff" }}>
              los reglamentos y políticas de privacidad
            </strong>{" "}
            para realizar pagos
          </CheckboxItem>

          <CheckboxItem
            checked={accepted.data}
            onChange={() =>
              setAccepted((prev) => ({ ...prev, data: !prev.data }))
            }
          >
            Acepto la{" "}
            <strong style={{ color: "#fff" }}>
              autorización para la administración de datos personales
            </strong>
          </CheckboxItem>
        </div>

        {/* Banner seguridad */}
        <div
          className="bg-purple"
          style={{
            borderRadius: "12px",
            padding: "12px 16px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <div
            style={{
              flexShrink: 0,
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              background: "#2a2550",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <rect
                x="5"
                y="11"
                width="14"
                height="10"
                rx="2"
                stroke="white"
                strokeWidth="1.8"
              />
              <path
                d="M8 11V7a4 4 0 1 1 8 0v4"
                stroke="white"
                strokeWidth="1.8"
                strokeLinecap="round"
              />
              <circle cx="12" cy="16" r="1.5" fill="white" />
            </svg>
          </div>
          <p style={{ fontSize: "14px", margin: 0 }}>
            <span style={{ color: "white" }}>Tus credenciales </span>
            <span style={{ color: "white", fontWeight: 700 }}>
              nunca pasan{" "}
            </span>
            <span style={{ color: "white" }}>
              por nosotros. Todo es directamente con tu entidad bancaria.
            </span>
          </p>
        </div>
      </div>

      {/* Botones — siempre al fondo */}

      <div
        className="w-full gap-4"
        style={{
          display: "flex",
          justifyContent: isDesktop ? "flex-end" : "stretch",
        }}
      >
        <div
          style={{
            width: isDesktop ? "400px" : "-webkit-fill-available",
            display: "flex",
            justifyContent: isDesktop && "center",
          }}
        >
          <PrevButton onBack={onBack} label={"Atrás"} isMobile={!isDesktop} />
          <NextButton
            onNext={onNext}
            label={"Conectar"}
            isMobile={!isDesktop}
            showIconNext={true}
            disabled={!allAccepted}
          />
        </div>
      </div>
    </div>
  );
};

// ════════════════════════════════════════════════════════════════
// STEP 4 — Éxito
// ════════════════════════════════════════════════════════════════
const Step4 = ({ isDesktop, onComplete }) => {
  const { height } = useWindowSize();

  let heightCanvan = height < 750 ? "17rem" : height > 900 ? "25rem" : "20rem";
  let widthCanvan = height < 750 ? "15rem" : height > 900 ? "23rem" : "20rem";

  let heightContainer =
    height < 750 ? "19rem" : height > 900 ? "30rem" : "20rem";
  return (
    <div className="flex flex-col items-center justify-center">
      {/* Componente de animación Rive */}
      <h1
        className="font-bold2"
        style={{
          fontSize: "2rem",
          width: "300px",
          textAlign: "center",
        }}
      >
        ¡Luz Púrpura para Continuar!
      </h1>
      <AnimationComponent
        animationUrl="/animations/checkanimation.riv"
        width={heightCanvan}
        height={widthCanvan}
        heightContainer={heightContainer}
        isDesktop={isDesktop}
        stateMachines={["chek-animation"]}
      />
      <p
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "200px",
        }}
      >
        <span>
          ¡<span style={{ color: "#A68AFF" }}>Felicitaciones</span>!
        </span>
        <span
          style={{
            textAlign: "center",
          }}
        >
          Conexión segura realizada.
        </span>
      </p>
      <p
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <span
          style={{
            textAlign: "center",
          }}
        >
          Nos hemos conectado a tu banco de manera exitosa.
        </span>
      </p>
      <AutoAdvance onNext={onComplete} delay={6000} />
    </div>
  );
};

// ════════════════════════════════════════════════════════════════
// ORQUESTADOR
// ════════════════════════════════════════════════════════════════
const NequiFlow = ({
  bankValue,
  onComplete,
  onBack,
  isDesktop,
  setProductAccount,
}) => {
  const [step, setStep] = useState(1);
  const [tokenIdWompi, setTokenIdWompi] = useState("");
  const [statusIdWompi, setStatusIdWompi] = useState("");
  const [product, setProduct] = useState("");
  const [, setTokenError] = useState(null);
  const number_document = localStorage.getItem("doc");
  const customer_email = localStorage.getItem("email");
  const { stepCredit, saveSteps, loadSteps } = stepsCreditStore();
  const { showAlert } = useAlert();

  useEffect(() => {
    loadSteps();
    if (step === 1) {
      validateTokenWompi();
    }
    // Efecto de solo montaje: valida una única vez si ya existe una
    // tokenización pendiente con Nequi. 'step' cambia por saveSteps/next(),
    // así que declararlo (o validateTokenWompi, que usa showAlert —
    // inestable entre renders— y consulta el endpoint de tokenización)
    // reejecutaría la validación en cada cambio de paso.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadSteps]);

  useEffect(() => {
    if (!stepCredit?.stepFlow) return;
    setStep(stepCredit.stepFlow);
  }, [stepCredit]);

  const next = () => {
    const nextStep = step + 1;
    setStep(nextStep);
    saveSteps({
      ...stepCredit,
      stepFlow: nextStep,
    });
  };

  const prev = () => {
    if (step === 1) {
      onBack();
      saveSteps({
        ...stepCredit,
        stepFlow: 1,
      });
    } else {
      const prevStep = step - 2;
      setStep(prevStep);
      saveSteps({
        ...stepCredit,
        stepFlow: prevStep,
      });
    }
  };

  const handleTokenize = async () => {
    setTokenError(null);

    // ← Explícito, no depende del closure de next()
    setStep(2);
    saveSteps({ ...stepCredit, stepFlow: 2 });
    setProductAccount(product);

    let payloadData = {
      phone_number: product,
      customer_email,
      number_document,
    };

    let payload = {
      bankName: "nequi",
      dataTokenization: payloadData,
    };

    try {
      const tokenSession = localStorage.getItem("token_jwt");

      const res = await axios.post(
        `${variablesGlobales.urlServiceBackend}/api/v1/tokenization/createTokenization`,
        payload,
        {
          headers: {
            authorization: `Bearer ${tokenSession}`,
            "X-API-KEY-GALILEA": variablesGlobales.x_api_key_wompi_checkout,
          },
        },
      );

      const data = res.data;

      if (data?.status === "PENDING") {
        if (data?.message) {
          showAlert("info", normalizeMessage(data.message), 6000);
        }
        setTokenIdWompi(data?.id);
        setStatusIdWompi(data?.status);
        setStep(3);
        saveSteps({ ...stepCredit, stepFlow: 3 });
      } else {
        showAlert(
          "info",
          data?.message || "Error al conectar tu cuenta Nequi",
          8000,
        );
        setTimeout(() => {
          setStep(1);
          saveSteps({ ...stepCredit, stepFlow: 1 });
        }, 5000);
      }
    } catch (err) {
      const errorMsg = err?.response?.data?.message;
      console.error("Wompi error:", err?.response?.data);
      showAlert("info", errorMsg, 8000);
      setTimeout(() => {
        setStep(1);
        saveSteps({ ...stepCredit, stepFlow: 1 });
      }, 5000);
    }
  };

  const validateTokenWompi = async () => {
    let payload = {
      doc: number_document,
    };

    try {
      const tokenSession = localStorage.getItem("token_jwt");

      const res = await axios.post(
        `${variablesGlobales.urlServiceBackend}/api/v1/tokenization/validate-tokenwompi`,
        payload,
        {
          headers: {
            authorization: `Bearer ${tokenSession}`,
            "X-API-KEY-GALILEA": variablesGlobales.x_api_key_wompi_checkout,
          },
        },
      );
      if (res.data) {
        const data = res.data.data;
        if (data?.status === "PENDING") {
          showAlert(
            "info",
            normalizeMessage(
              "Tienes una solicitud de conexión pendiente con tu banco.",
            ),
            6000,
          );
          setTokenIdWompi(data?.id);
          setStatusIdWompi(data?.status);
          setStep(3);
          saveSteps({ ...stepCredit, stepFlow: 3 });
        } else {
          setStep(1);
          saveSteps({ ...stepCredit, stepFlow: 1 });
        }
      }
    } catch (err) {
      const errorMsg = err?.response?.data?.message;
      showAlert("info", errorMsg, 8000);
      setTimeout(() => {
        setStep(1);
        saveSteps({ ...stepCredit, stepFlow: 1 });
      }, 5000);
    }
  };

  const handlePaymentMethod = async () => {
    setTokenError(null);

    let payloadData = {
      id: tokenIdWompi,
    };

    let payload = {
      bankName: "nequi",
      dataTokenization: payloadData,
    };

    try {
      const tokenSession = localStorage.getItem("token_jwt");

      const res = await axios.post(
        `${variablesGlobales.urlServiceBackend}/api/v1/tokenization/status`,
        payload,
        {
          headers: {
            authorization: `Bearer ${tokenSession}`,
            "X-API-KEY-GALILEA": variablesGlobales.x_api_key_wompi_checkout,
          },
        },
      );

      const data = res.data;

      if (data?.status === "AVAILABLE") {
        showAlert("info", normalizeMessage(data?.data.message), 6000);
        localStorage.setItem("tokenIdWompi", data?.data.id);
        setStep(4);
        saveSteps({ ...stepCredit, stepFlow: 4 });
      } else {
        showAlert(
          "info",
          data?.data.message || "Error al conectar tu cuenta Nequi",
          8000,
        );
        setTimeout(() => {
          setStep(3);
          saveSteps({ ...stepCredit, stepFlow: 3 });
        }, 5000);
      }
    } catch (err) {
      const errorMsg = err?.response?.data?.message;
      console.error("Wompi error:", err?.response?.data);
      showAlert("info", errorMsg, 8000);
      setTimeout(() => {
        setStep(3);
        saveSteps({ ...stepCredit, stepFlow: 3 });
      }, 5000);
    }
  };

  switch (step) {
    case 1:
      return (
        <Step1
          onNext={handleTokenize}
          onBack={prev}
          isDesktop={isDesktop}
          bank={bankValue}
          product={product}
          setProduct={setProduct}
        />
      );
    case 2:
      return (
        <Step2
          onNext={next}
          onBack={prev}
          isDesktop={isDesktop}
          bank={bankValue}
          product={product}
        />
      );
    case 3:
      return (
        <Step3
          onNext={handlePaymentMethod}
          onBack={prev}
          isDesktop={isDesktop}
          bank={bankValue}
          statusIdWompi={statusIdWompi}
        />
      );
    case 4:
      return (
        <Step4
          // onComplete={onComplete({ phoneNumber: product })}
          onComplete={() => onComplete({ phoneNumber: product })}
          onBack={prev}
          isDesktop={isDesktop}
          bank={bankValue}
        />
      );
    default:
      return null;
  }
};

export default NequiFlow;
